import { useMemo } from 'react';
import { useRegionalConfiguration } from '@tn/foundation/entities/regional-configuration/hooks/useRegionalConfiguration';
import useRegion from '@tn/foundation/hooks/providers/useRegion';
import { useRouter } from 'next/router';
import { UnknownMachineConfig } from 'xstate';

import { decideFlowId } from './helpers';

const useGetMachineConfig = () => {
    const { region } = useRegion();
    const { getConfigByKey } = useRegionalConfiguration({ appName: 'signup', region });
    const router = useRouter();

    const flowId = useMemo(
        () => decideFlowId(router.pathname, getConfigByKey, region),
        [router.pathname, getConfigByKey, region],
    );

    if (!flowId) {
        return null;
    }

    return getConfigByKey(`${flowId}.machineConfig`) as UnknownMachineConfig;
};

export default useGetMachineConfig;
